module.exports = __webpack_public_path__ + "static/media/timelapse_21.79ee6aed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/timelapse_21.jpg
// module id = 979
// module chunks = 0